// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__3dw5I","wrapper":"Item_wrapper__1YmwS","name":"Item_name__3fYzg","msg":"Item_msg__AMeTX"};